import React, { memo } from "react";
import { useTranslation } from "react-i18next";

interface SidebarErrorStateProps {
  error: string;
}

const SidebarErrorState: React.FC<SidebarErrorStateProps> = memo(({ error }) => {
  const { t } = useTranslation();
  
  return (
    <div className="error-state">
      <div className="error-icon">⚠️</div>
      <div className="error-message">
        <h4>{t("errors.failedToLoadMap")}</h4>
        <p>{error}</p>
      </div>
    </div>
  );
});

SidebarErrorState.displayName = "SidebarErrorState";

export default SidebarErrorState;
